module.exports = __webpack_public_path__ + "media/images/logo-4c8be893.svg";